import { ReactNode } from 'react'
import { useSearchParams } from 'react-router-dom'

import { Box, Button, Grid, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { EditionWindow } from 'modules/performance_process/components/review/EditionWindow/EditionWindow'

import { OptionType } from './types'

type Props = {
  options: OptionType[]
  isDirty: boolean
  children: ReactNode
  isDisabled: boolean
  setSaved: (value: boolean) => void
  defaultSection: string
}

export const EditModeLayout = ({
  options,
  children,
  isDirty,
  isDisabled,
  setSaved,
  defaultSection,
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedSection = searchParams.get('section') ?? defaultSection
  return (
    <>
      <>
        <Grid variant="small">
          <Box padding="s24" gridColSpan={{ xs: 2 }} gap="s8">
            {options.map((option) => {
              return (
                <EditionWindow
                  key={option.label}
                  label={option.label}
                  value={option.value}
                  selected={option.value === selectedSection}
                  icon={option.icon}
                  onChange={(value: string) => {
                    setSearchParams({ section: value })
                  }}
                />
              )
            })}
          </Box>
          <Box gridColSpan={{ s: 3 }}>{children}</Box>
        </Grid>
      </>
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        position="sticky"
        maxHeight="fit-content"
        style={{
          bottom: '0',
          marginTop: '16px',
          zIndex: '100',
        }}
        width="full"
        background="white"
        paddingY="s16"
        paddingRight="s64"
        paddingLeft="s24"
        border={{
          top: {
            width: 's2',
            style: 'solid',
            color: 'grey400',
          },
        }}
      >
        <Tag icon={isDirty ? 'alert' : 'check'} type="transparent" leftItem="icon">
          {isDirty
            ? i18n.t('trainings.edit_mode.footer.need_save')
            : i18n.t('trainings.edit_mode.footer.all_saved')}
        </Tag>
        <Button onClick={() => setSaved(true)} type="secondary" disabled={isDisabled} submit>
          {i18n.t('trainings.edit_mode.footer.new_button')}
        </Button>
      </Box>
    </>
  )
}
